"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Arrow = require("./Arrow");
Object.keys(_Arrow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Arrow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Arrow[key];
    }
  });
});